import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import {
  PaintColorMaterial,
  PaintColorMaterialDark,
} from '../../utils/materials';

export function Lattice_3drawer_dresser(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Lattice 3-Drawer Dresser.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-lattice_3_drawer_dresser-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    PaintColorMaterialDark,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    "ao-lattice_3_drawer_dresser-interior",
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.interior.geometry}
        material={PaintColorMaterialDark}
      />
      <mesh
        castShadow
        geometry={nodes.Screw.geometry}
        material={materials.Screw}
      />
      <Shadow model={'Lattice 3-Drawer Dresser'} />
    </group>
  );
}
